import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'bringozTimeHHMM'
})
export class BringozTimeHHMMPipe implements PipeTransform {

  transform(timeInMillis: number): string {
    if (!timeInMillis) {
      return '---';
    }

    const totalSeconds = Math.floor(timeInMillis / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }
}

